import { apiClient } from '@/lib/api-client';

export interface SenderProfile {
  SenderProfileID: string;
  TenantOrganizationID: string | null;
  ProfileName: string;
  Channel: 'Email' | 'WhatsApp';
  SMTPServer: string | null;
  SMTPPort: number | null;
  UseTLS: number | boolean;
  UserID: string | null;
  HasPassword: boolean;
  FromEmail: string | null;
  FromName: string | null;
  GatewayTextURL: string | null;
  GatewayCaptionURL: string | null;
  GatewayAttachmentURL: string | null;
  GatewayKey: string | null;
  IsDefault: number | boolean;
  Status: string;
}

export interface SenderProfileInput {
  id?: string;
  profileName: string;
  channel: 'Email' | 'WhatsApp';
  smtpServer?: string;
  smtpPort?: number;
  useTls?: boolean;
  userId?: string;
  password?: string;        // write-only — never echoed back
  fromEmail?: string;
  fromName?: string;
  gatewayTextUrl?: string;
  gatewayCaptionUrl?: string;
  gatewayAttachmentUrl?: string;
  gatewayKey?: string;
  isDefault?: boolean;
  status?: string;
}

export const senderProfilesApi = {
  list(): Promise<SenderProfile[]> {
    return apiClient.get('/admin/sender-profiles');
  },
  save(input: SenderProfileInput): Promise<{ id: string }> {
    return apiClient.post('/admin/sender-profiles', input);
  },
  test(id: string, to: string): Promise<{ success: boolean; error?: string }> {
    return apiClient.post(`/admin/sender-profiles/${id}/test`, { to });
  },
};
